module.exports = __webpack_public_path__ + "static/incursion_mercados-53e0b366f9b0ea8d6b1ff804f2f79f27.png";